import * as Styled from './GetHelp.styled';

import { ListItem } from '@capra/core';
import React from 'react';

type HelpItem = { title: string; description: string; link: string };

export const GET_HELP_ITEMS_LIST: readonly HelpItem[] = [
  {
    title: 'Getting Started Guide',
    description: 'Walk-throughs of basic Cribl Stream deployments',
    link: 'https://docs.cribl.io/docs/getting-started-guide',
  },
  {
    title: 'Documentation',
    description: 'Guides, reference, use cases, and tips',
    link: 'https://docs.cribl.io/',
  },
  process.env.CRIBL_SANDBOX_ENABLED === 'true'
    ? {
      title: 'Sandboxes',
      description: 'Free interactive tutorials with live, hosted Cribl integrations',
      link: 'https://sandbox.cribl.io/',
    }
    : null,
  {
    title: 'Cribl University',
    description: 'Free Cribl training and certifications',
    link: 'https://cribl.io/university/',
  },
  {
    title: 'Cribl Concepts',
    description: 'Short videos for quick learning',
    link: 'https://vimeo.com/showcase/7456313',
  },
].filter((value): value is NonNullable<HelpItem> => value !== null);

export const GetHelp: React.FC = () => (
  <Styled.GetHelpList>
    {GET_HELP_ITEMS_LIST.map((item) => (
      <ListItem key={item.title}>
        <a
          href={item.link}
          target='_blank'
          rel='nofollow noopener'
        >
          <ListItem.Content>
            <ListItem.Label>{item.title}</ListItem.Label>
            <ListItem.Description>{item.description}</ListItem.Description>
          </ListItem.Content>
        </a>
      </ListItem>
    ))}
  </Styled.GetHelpList>
);
